import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { API_CONFIG } from 'src/app/config/api.config';

@Injectable({
  providedIn: 'root'
})
export class GeolocalizacaoService {

  constructor( private http: HttpClient ) { }



  /**
   * Obtém o IP do cliente, depois as coordenadas, e por fim o endereço com o Google
   */
  getGeolocalizacao(): Observable<any> {
    return this.getCoordenadasPorIP().pipe(
      switchMap(resp => {
        return this.getEnderecoNominatim(resp.latitude, resp.longitude);
      }),
      catchError(error => {
        return of(null); // ou você pode usar throwError(error) se preferir propagar o erro
      })
    );
  }
  

  getIpCliente(): Observable<any> {
    const url = `${API_CONFIG.apiURL}/geoplugin/getIpCliente`;
    
    return this.http.get<any>(url);
  }
  
  /**
   * Consulta coordenadas baseadas no IP (via backend)
   */
  getCoordenadasPorIP(): Observable<any> {
    const url = `${API_CONFIG.apiURL}/geoplugin/getCoordenadas`;
    //console.log('[LOG] URL chamada para coordenadas por IP:', url);

    return this.http.get<any>(url);
  }

  getEnderecoNominatim(lat: any, lon: any): Observable<any> {
    const url = `/nominatim/reverse?format=json&lat=${lat}&lon=${lon}`;
    //console.log('[LOG] URL gerada para Nominatim:', url);

    return this.http.get<any>(url);
  }

  
}
